import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Typography } from '@components/Typography';

const Row = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
});

const Controls = styled('div')({
    display: 'flex',
    width: 70,
    flex: 'none',
    justifyContent: 'space-between',
    alignItems: 'center',
});

const iconStyles = { width: '16px', fill: '#8FA6AE' };

const buttonStyles = { height: 24, padding: 8, width: 24 };

const QuantityStepper = ({ label, caption, value, min, onChange }) => {
    const atMin = value <= min;

    return (
        <Row>
            <div>
                <Typography variant="body2">{label}</Typography>
                {caption ? (
                    <Typography variant="caption" sx={{ display: 'block', color: 'var(--text-tertiary)' }}>
                        {caption}
                    </Typography>
                ) : null}
            </div>
            <Controls>
                <IconButton disabled={atMin} onClick={() => onChange(value - 1)} style={buttonStyles}>
                    <RemoveCircleIcon sx={{ opacity: atMin ? 0.5 : 1, ...iconStyles }} />
                </IconButton>
                <Typography variant="subtitle1">{value}</Typography>
                <IconButton onClick={() => onChange(value + 1)} style={buttonStyles}>
                    <AddCircleIcon sx={iconStyles} />
                </IconButton>
            </Controls>
        </Row>
    );
};

export default QuantityStepper;
